import { Button, Dialog, DialogActions, DialogContent, DialogProps } from "@mui/material";
import React from "react";
import { OrganizationDataRecipientDto } from "../../../common/service/server/dto/OrganizationDataRecipientDto";
import { CloseableDialogTitle } from "./CloseableDialogTitle";

type ConfirmDialogProps = {
  open: boolean;
  onClose: () => void;
  vendors: OrganizationDataRecipientDto[];
  title?: string;
  cls?: string;
  allowToggle?: boolean;
  isRecipientRemoved?: (v: OrganizationDataRecipientDto) => boolean;
  addRecipient?: (v: OrganizationDataRecipientDto) => void;
  removeRecipient?: (v: OrganizationDataRecipientDto) => void;
} & DialogProps;

export const VendorEmailDisplayDialog: React.FC<ConfirmDialogProps> = ({
  open,
  onClose,
  vendors,
  title = "Notification Recipients",
  maxWidth = "lg",
  allowToggle = false,
  isRecipientRemoved,
  addRecipient,
  removeRecipient,
  cls,
  ...props
}) => {
  if (allowToggle && (!isRecipientRemoved || !addRecipient || !removeRecipient)) {
    throw new Error("Cannot create togglable display dialog without required properties");
  }
  return (
    <Dialog
      fullWidth={true}
      maxWidth={maxWidth}
      open={open}
      onClose={onClose}
      className={`get-compliant-dialog confirm-dialog ${cls ? cls : ""}`}
      {...props}
    >
      <CloseableDialogTitle onClose={onClose}>{title}</CloseableDialogTitle>

      <DialogContent>
        <div className="flex-container flex-row flex--wrap">
          {vendors
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((v) => {
              return (
                <div
                  key={v.id}
                  className={`${
                    vendors.length === 1 ? "w-100" : "w-50"
                  } p-md mr-0 mb-std flex-container flex-row flex--between align-items-center`}
                >
                  <div
                    className={`flex-container ${
                      !allowToggle || isRecipientRemoved(v) ? "opacity-50" : ""
                    }`}
                  >
                    <div className="w-space-xl align-top mr-md" style={{ flexShrink: 0 }}>
                      <img
                        src={v.logoUrl || "/assets/images/icon-vendors-black.svg"}
                        className="w-100"
                      />
                    </div>

                    <div className="flex-grow">
                      <div className="text-t5 text-weight-bold">{v.name}</div>
                      <a href={`mailto:${v.email}`}>{v.email || v.defaultEmail}</a>
                    </div>
                  </div>
                  {allowToggle && (
                    <div>
                      {isRecipientRemoved(v) ? (
                        <Button
                          color="primary"
                          size="small"
                          variant="contained"
                          onClick={() => addRecipient(v)}
                        >
                          Add as Recipient
                        </Button>
                      ) : (
                        <Button size="small" variant="outlined" onClick={() => removeRecipient(v)}>
                          Remove
                        </Button>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
        </div>
      </DialogContent>
      <DialogActions>
        <Button color="primary" variant="contained" onClick={onClose} className="ml-sm">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
